import React from 'react';
interface PillProps {
  children: React.ReactNode;
  tone?: 'accent' | 'danger' | 'outline';
  /** Let long labels wrap onto a second line on narrow screens. */
  wrap?: boolean;
  className?: string;
}
const tones: Record<string, string> = {
  accent: 'border-orange-400/40 bg-orange-400/10 text-orange-400 [.chalk_&]:border-orange-600/40 [.chalk_&]:bg-orange-600/10 [.chalk_&]:text-orange-600',
  danger: 'border-red-400/40 bg-red-400/10 text-red-400 [.chalk_&]:border-red-600/40 [.chalk_&]:bg-red-600/10 [.chalk_&]:text-red-600',
  outline: 'border-slate-800 bg-slate-800 text-slate-400 [.chalk_&]:border-slate-200 [.chalk_&]:bg-slate-100 [.chalk_&]:text-slate-600'
};
export function Pill({
  children,
  tone = 'accent',
  wrap = false,
  className = ''
}: PillProps) {
  const wrapping = wrap ? 'rounded-2xl py-1.5 leading-snug' : 'whitespace-nowrap rounded-full py-1 leading-none';
  return <span className={`inline-flex items-center justify-center border px-3.5 text-center text-xs font-semibold uppercase tracking-[0.16em] ${wrapping} ${tones[tone]} ${className}`} style={{
    fontSize: "10px"
  }} data-id="element-177" data-mp="1ymfwkasr7uok">
      {children}
    </span>;
}